export const ADMIN_USER = 'USER-ADMIN';
